import React, {Fragment} from "react";
import Grid from "@mui/material/Grid";
import {withTranslation} from "react-i18next";
import AutoSearchInput from "../../auto-search-input";

const PreHeader = ({
  t,
  searchText,
  onSearch,
  selectedRowCount,
  tableActions,
  renderTableAction,
  leftActions,
  rightActions,
  showSelectedCount
}) => {
  const hasToolbarActions =
    (leftActions !== null && leftActions !== undefined) || (rightActions !== null && rightActions !== undefined);

  const leftColSPan = hasToolbarActions ? 6 : showSelectedCount ? 3 : 0;

  return (
    <Grid container style={{marginBottom: 4}}>
      <Grid size={leftColSPan}>
        <Grid container justifyContent="space-between">
          <Grid>{leftActions}</Grid>
          <Grid>
            <Grid container justifyContent="flex-end">
              {tableActions && selectedRowCount > 0 && (
                <Fragment>
                  {showSelectedCount && (
                    <Grid style={{padding: "12px 16px 12px 8px"}}>
                      {t("components.infiniteScrollTable.preHeader.selectedCount", {count: selectedRowCount})}
                    </Grid>
                  )}
                  {tableActions.map((action, index) => (
                    <Grid key={index}>{renderTableAction(action)}</Grid>
                  ))}
                </Fragment>
              )}
              {rightActions && <Grid>{rightActions}</Grid>}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        className="infinite-scroll-table__pre-header__search-bar"
        size={12 - leftColSPan}
        style={{padding: "8px 0"}}
      >
        <AutoSearchInput value={searchText} onSearch={onSearch} />
      </Grid>
    </Grid>
  );
};

export default withTranslation()(PreHeader);
